import { createHelpers } from 'vuex-map-fields';

const { getAggregatorStateField, updateAggregatorStateField } = createHelpers({
    getterType: `getAggregatorStateField`,
    mutationType: `updateAggregatorStateField`,
});


const state = {
    can_close_modal : true,
    is_load : false,
    is_load_complete : false,
    aggregator_item : {
        is_init : false,
        provider : {
            id : 0,
            human_name : "",
        },
        params_type : {

        },

        aggregators_params : {
            has_head : false,
        },
        basic_params : {
            id : 0,
        },
    },
};

// actions
const actions = {
    LOAD_OUT_PROVIDER({commit},pos_id) {
        commit('set_load',true);
        commit('set_load_complete',false);

        agr_api.get('/aggregators/' + pos_id).then(({data}) => {
            if(data.status === 'operation_success') {
                commit('set_pos', data.data);
            }
        }).catch(({response}) => {
            commit('set_load',false);
            EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,	position : "b-toaster-top-left"})
            console.log(response);
        });
    },
};

// mutations
const mutations = {
    core_const (state, data) {
        state.core_const = {...state.core_const, ...data}
    },

    set_pos (state,data) {
        state.aggregator_item = {...state.aggregator_item, ...data}
        state.is_load = false;
        state.is_load_complete = true;
        EventBus.$emit('load_aggregator_provider',state.aggregator_item);
    },

    set_load(state,is_load) {
        state.is_load = is_load;
    },

    set_load_complete(state,is_load) {
        state.is_load_complete = is_load;
    },
};

const getters = {
    getAggregator(state) {
        return state.aggregator_item;
    },

    is_load(state) {
        return state.is_load;
    },

    is_load_complete(state) {
        return state.is_load_complete;
    },

    getAggregatorStateField,

};


export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations,
}
